<template>
  <UiDialog
    :aperto="aperto"
    :titolo="t('layout.versione.titolo')"
    :descrizione="t('layout.versione.testo')"
    size="sm"
    centrato
    foco-iniziale="dialogo"
    :chiudibile="false"
    :chiudi-con-esc="false"
    :chiudi-su-sfondo="false"
  >
    <!-- Il logo sta in un tondo di vetro con un anello che gira piano: «sta succedendo qualcosa» senza essere un caricamento -->
    <div class="flex justify-center py-1" data-test="versione-logo">
      <!-- overflow-hidden: l'anello ruota e il suo riquadro sporgerebbe agli angoli, facendo comparire a intermittenza la barra di scorrimento del dialogo -->
      <span class="relative grid size-28 place-items-center overflow-hidden rounded-full border border-border bg-glass-solid">
        <span
          class="absolute inset-0 rounded-full bg-[conic-gradient(from_0deg,transparent,var(--color-accent),transparent)] [mask-image:radial-gradient(farthest-side,transparent_calc(100%-3px),#000_calc(100%-2px))] motion-safe:animate-spin motion-safe:[animation-duration:3s] motion-reduce:opacity-50"
          aria-hidden="true"
        />
        <AppLogo fill class="size-16" />
      </span>
    </div>
    <template #footer>
      <UiButton icon="fal fa-arrows-rotate" icon-hover="rotate" :loading="inCorso" :label="t('layout.versione.aggiorna')" @click="emit('aggiorna')" />
    </template>
  </UiDialog>
</template>

<script setup lang="ts">
// Avviso «nuova versione dell'app»: finestra centrata che obbliga ad aggiornare (svuota le cache e ricarica). La logica sta nel layout.
import { useI18n } from "vue-i18n";

defineProps<{ aperto: boolean; inCorso?: boolean }>();
const emit = defineEmits<{ aggiorna: [] }>();
const { t } = useI18n();
</script>
